import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../Styles/CoverImageUploader.css"
import { FaCamera } from "react-icons/fa"; // Importing camera icon
import ProfileImageUploader from "./CoverImageUploader";
import { right } from "@popperjs/core";

const MpCoverImageUploader = ({ coverImage, setCoverImage, userId }) => {
    const navigate = useNavigate();
    const [isFriend, setIsFriend] = useState(true);
    const [requestSent, setRequestSent] = useState(false);
    const [showDetail, setShowDetail] = useState(false);

    const [profileImage, setProfileImage] = useState("/assets/User/Aarushi.JPG"); 

    const handleImageUpload = (event) => {
        const file = event.target.files[0];
        if (file) {
            const imageUrl = URL.createObjectURL(file);
            setCoverImage(imageUrl);
        }
    };

    const handleConnect = () => {
      if (!isFriend && !requestSent) {
        setRequestSent(true);
        // Simulate a request send
        setTimeout(() => {
          console.log("Connect request sent to", userId);
        }, 500);
      }
    };
  
    const handleDetail = () => {
      if (isFriend) {
        setShowDetail(!showDetail);
      }
    };

    return (
        <div style={{display: "flex", flexDirection: "row"}}>
            <div className="mp-cover-container-left" style={{justifyContent: "center", marginTop: 15}}>
            <div>
                <img src={profileImage} alt="Profile" className="mp-profile-photo" style={{marginLeft: -17}}/>
            </div>
    </div>
    <div className="mp-cover-container-right">
        <button className="mp-cover-container-button"
                  disabled={isFriend || requestSent}
                  onClick={handleConnect}
        > {isFriend ? 'Connected' : requestSent ? 'Request Sent' : 'Connect'} 
        </button>
        <button className="mp-cover-container-button"
            disabled={!isFriend}
            onClick={handleDetail}
        > detail </button>
    </div>
    <div className="mp-cover-container-User">
    <h3 style={{color: "black", fontSize: 50}}>{userId}</h3>
    </div>

    {showDetail && (
        <div className="user-details-box">
          <h4 className="mp-user-text-props" style={{fontSize: 30}}> Details for {userId} </h4>
          <p className="mp-user-text-props"> Email: {"SpeakerNotesSharp.padhy@gmail.com"} </p>
          <p className="mp-user-text-props"> City: {"Bangalore"}</p>
          <p className="mp-user-text-props"> Bio: {"bio"}</p>
        </div>
      )}
    </div>
    );
};

export default MpCoverImageUploader;